import { useEffect, useMemo, useState } from "react";

export const ADMIN_SHELL_MENU_GROUPS = [
  {
    key: "operations",
    label: "核心运营",
    items: [
      { key: "dashboard", label: "仪表盘", route: "home" },
      {
        key: "orders",
        label: "订单管理",
        route: "orders",
        children: [
          {
            key: "orders-fulfillment-group",
            label: "履约与进度",
            icon: "stage",
            children: [
              { key: "orders-all", label: "全部订单", route: "orders" },
              { key: "orders-paid-queue", label: "待履约订单", route: "ordersPaidQueue" },
              { key: "orders-in-transit", label: "运输跟踪", route: "ordersInTransit" },
              { key: "orders-completed", label: "已完成订单", route: "ordersCompleted" }
            ]
          },
          {
            key: "orders-service-group",
            label: "售后与异常",
            icon: "service",
            children: [
              { key: "orders-after-sales", label: "取消与售后", route: "ordersAfterSales" }
            ]
          }
        ]
      },
      {
        key: "products",
        label: "商品管理",
        route: "products",
        children: [
          {
            key: "products-catalog-group",
            label: "商品与建档",
            icon: "catalog",
            children: [
              { key: "products-list", label: "商品列表", route: "products" },
              { key: "products-create", label: "新增商品", route: "productCreate" },
              { key: "products-merchandising", label: "选品中心", route: "merchandising" }
            ]
          },
          {
            key: "products-supply-group",
            label: "供应链协同",
            icon: "supply",
            children: [
              { key: "products-procurement", label: "采购协同", route: "procurement" },
              { key: "products-quality", label: "质检与方案", route: "solutions" },
              { key: "products-logistics", label: "物流协同", route: "logistics" }
            ]
          }
        ]
      },
      {
        key: "customers",
        label: "客户管理",
        route: "customers",
        children: [
          {
            key: "customers-crm-group",
            label: "客户运营",
            icon: "crm",
            children: [
              { key: "customers-list", label: "客户列表", route: "customers" },
              { key: "customers-segments", label: "客户分层", route: "customersSegments" },
              { key: "customers-tags", label: "标签洞察", route: "customersTags" }
            ]
          },
          {
            key: "customers-inquiry-group",
            label: "询盘与跟进",
            icon: "inquiry",
            children: [
              { key: "customers-inquiries", label: "询盘记录", route: "inquiry" }
            ]
          }
        ]
      }
    ]
  },
  {
    key: "growth",
    label: "增长与内容",
    items: [
      {
        key: "content",
        label: "内容管理",
        route: "articleManagement",
        children: [
          {
            key: "content-brand-group",
            label: "品牌与店铺",
            icon: "storefront",
            children: [
              { key: "content-store-base", label: "店铺基础", route: "storeBase" },
              { key: "content-template-studio", label: "模板工作台", route: "templateStudio" },
              { key: "content-navigation", label: "导航菜单", route: "designNav" },
              { key: "content-carousel", label: "横幅管理", route: "designCarousel" }
            ]
          },
          {
            key: "content-assets-group",
            label: "内容资产",
            icon: "asset",
            children: [
              { key: "content-articles", label: "文章管理", route: "articleManagement" },
              { key: "content-company-images", label: "公司图集", route: "companyImages" },
              { key: "content-faq", label: "FAQ 与评论", route: "faqKnowledge" }
            ]
          }
        ]
      },
      {
        key: "marketing",
        label: "营销中心",
        route: "marketing",
        children: [
          {
            key: "marketing-campaign-group",
            label: "活动与定价",
            icon: "campaign",
            children: [
              { key: "marketing-campaign", label: "活动总览", route: "marketing" },
              { key: "marketing-coupon", label: "优惠策略", route: "discounts" }
            ]
          },
          {
            key: "marketing-delivery-group",
            label: "投放与触达",
            icon: "reach",
            children: [
              { key: "marketing-poster", label: "素材排期", route: "marketingPoster" },
              { key: "marketing-email", label: "触达邮件", route: "marketingEmail" }
            ]
          }
        ]
      },
      {
        key: "analytics",
        label: "数据分析",
        route: "analytics",
        children: [
          {
            key: "analytics-business-group",
            label: "经营分析",
            icon: "insight",
            children: [
              { key: "analytics-traffic", label: "经营总览", route: "analytics" },
              { key: "analytics-sales", label: "销售分析", route: "analyticsSales" }
            ]
          },
          {
            key: "analytics-entity-group",
            label: "对象分析",
            icon: "audience",
            children: [
              { key: "analytics-products", label: "商品分析", route: "analyticsProducts" },
              { key: "analytics-customers", label: "客户分析", route: "analyticsCustomers" }
            ]
          }
        ]
      },
      {
        key: "finance",
        label: "财务中心",
        route: "finance",
        children: [
          {
            key: "finance-funds-group",
            label: "资金与往来",
            icon: "wallet",
            children: [
              { key: "finance-overview", label: "财务总览", route: "finance" },
              { key: "finance-income", label: "入账流水", route: "financeIncome" },
              { key: "finance-expenses", label: "支出账单", route: "financeExpenses" },
              { key: "finance-receivables", label: "应收账款", route: "financeReceivables" },
              { key: "finance-payables", label: "应付账款", route: "financePayables" }
            ]
          },
          {
            key: "finance-tax-group",
            label: "票税与预算",
            icon: "receipt",
            children: [
              { key: "finance-invoices", label: "发票管理", route: "financeInvoices" },
              { key: "finance-tax", label: "税务管理", route: "financeTax" },
              { key: "finance-budget", label: "预算费用", route: "financeBudget" }
            ]
          },
          {
            key: "finance-closing-group",
            label: "结账与对账",
            icon: "closing",
            children: [
              { key: "finance-daily", label: "日账单", route: "financeDaily" },
              { key: "finance-monthly", label: "月度结账", route: "financeMonthly" },
              { key: "finance-yearly", label: "财务年报", route: "financeYearly" },
              { key: "finance-reconciliation", label: "收支对账", route: "financeReconciliation" }
            ]
          },
          {
            key: "finance-report-group",
            label: "审批与报表",
            icon: "audit",
            children: [
              { key: "finance-approvals", label: "审批审计", route: "financeApprovals" },
              { key: "finance-reports", label: "报表导出", route: "financeReports" }
            ]
          }
        ]
      }
    ]
  },
  {
    key: "organization",
    label: "团队与维护",
    items: [
      {
        key: "team",
        label: "成员与人事",
        route: "positionMaintenance",
        children: [
          {
            key: "team-governance-group",
            label: "组织与权限",
            icon: "governance",
            children: [
              { key: "team-users", label: "成员与权限", route: "positionMaintenance" }
            ]
          },
          {
            key: "team-hr-group",
            label: "人事与协同",
            icon: "hr",
            children: [
              { key: "team-hr-employee", label: "员工档案", route: "hrEmployee" },
              { key: "team-hr-recruitment", label: "招聘与入岗", route: "hrRecruitment" },
              { key: "team-hr-attendance", label: "考勤与活跃", route: "hrAttendance" },
              { key: "team-hr-office", label: "行政协同", route: "hrOffice" }
            ]
          }
        ]
      },
      {
        key: "notifications",
        label: "通知管理",
        route: "notifications",
        children: [
          {
            key: "notifications-delivery-group",
            label: "发布与收件",
            icon: "notify",
            children: [
              { key: "notifications-manage", label: "发布与通知池", route: "notifications" }
            ]
          },
          {
            key: "notifications-plan-group",
            label: "编排计划",
            icon: "planning",
            children: [
              { key: "notifications-plans", label: "通知计划", route: "notificationPlan" }
            ]
          }
        ]
      },
      {
        key: "settings",
        label: "系统与维护",
        route: "settings",
        children: [
          {
            key: "settings-core-group",
            label: "系统配置",
            icon: "system",
            children: [
              { key: "settings-basic", label: "基础设置", route: "settings" }
            ]
          },
          {
            key: "settings-ops-group",
            label: "运行维护",
            icon: "ops",
            children: [
              { key: "settings-runtime", label: "运行探针", route: "siteMaintenance" }
            ]
          }
        ]
      }
    ]
  }
];

export const ADMIN_SHELL_MENUS = ADMIN_SHELL_MENU_GROUPS.flatMap((group) => group.items);

const ACTIVE_MENU_BY_TAB = {
  home: "dashboard",
  orders: "orders-all",
  ordersPaidQueue: "orders-paid-queue",
  ordersInTransit: "orders-in-transit",
  ordersCompleted: "orders-completed",
  ordersAfterSales: "orders-after-sales",
  products: "products-list",
  productCreate: "products-create",
  merchandising: "products-merchandising",
  procurement: "products-procurement",
  solutions: "products-quality",
  logistics: "products-logistics",
  customers: "customers-list",
  customersSegments: "customers-segments",
  customersTags: "customers-tags",
  inquiry: "customers-inquiries",
  articleManagement: "content-articles",
  designNav: "content-navigation",
  storeBase: "content-store-base",
  templateStudio: "content-template-studio",
  designCarousel: "content-carousel",
  companyImages: "content-company-images",
  faqKnowledge: "content-faq",
  marketing: "marketing-campaign",
  discounts: "marketing-coupon",
  marketingPoster: "marketing-poster",
  marketingEmail: "marketing-email",
  analytics: "analytics-traffic",
  analyticsSales: "analytics-sales",
  analyticsProducts: "analytics-products",
  analyticsCustomers: "analytics-customers",
  finance: "finance-overview",
  financeIncome: "finance-income",
  financeExpenses: "finance-expenses",
  financeReceivables: "finance-receivables",
  financePayables: "finance-payables",
  financeInvoices: "finance-invoices",
  financeTax: "finance-tax",
  financeBudget: "finance-budget",
  financeDaily: "finance-daily",
  financeMonthly: "finance-monthly",
  financeYearly: "finance-yearly",
  financeReconciliation: "finance-reconciliation",
  financeApprovals: "finance-approvals",
  financeReports: "finance-reports",
  notifications: "notifications-manage",
  notificationPlan: "notifications-plans",
  settings: "settings-basic",
  positionMaintenance: "team-users",
  hrEmployee: "team-hr-employee",
  hrRecruitment: "team-hr-recruitment",
  hrAttendance: "team-hr-attendance",
  hrOffice: "team-hr-office",
  siteMaintenance: "settings-runtime"
};

export function getAdminShellActiveMenu(tab) {
  return ACTIVE_MENU_BY_TAB[String(tab || "home").trim()] || "dashboard";
}

function flattenMenuChildren(children = []) {
  return children.flatMap((child) => (Array.isArray(child?.children) ? flattenMenuChildren(child.children) : [child]));
}

function itemHasSelectedDescendant(item, selectedKey) {
  return flattenMenuChildren(item?.children || []).some((child) => child?.key === selectedKey);
}

function filterAllowedChildren(children = [], activeTab, allowedTabSet) {
  return children
    .map((child) => {
      const nestedChildren = Array.isArray(child?.children)
        ? filterAllowedChildren(child.children, activeTab, allowedTabSet)
        : [];
      const normalizedRoute = String(child?.route || "").trim();
      const routeAllowed = normalizedRoute === "home" || normalizedRoute === String(activeTab || "").trim() || allowedTabSet.has(normalizedRoute);

      if (nestedChildren.length) {
        return {
          ...child,
          children: nestedChildren
        };
      }

      if (!normalizedRoute || !routeAllowed) {
        return null;
      }

      return child;
    })
    .filter(Boolean);
}

export function AdminShellIcon({ name }) {
  const icons = {
    dashboard: <path d="M4 11.5a1.5 1.5 0 0 1 1.5-1.5h4a1.5 1.5 0 0 1 1.5 1.5v6A1.5 1.5 0 0 1 9.5 19h-4A1.5 1.5 0 0 1 4 17.5zm9-5A1.5 1.5 0 0 1 14.5 5h4A1.5 1.5 0 0 1 20 6.5v11a1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5zm-9-1A1.5 1.5 0 0 1 5.5 4h4A1.5 1.5 0 0 1 11 5.5v1A1.5 1.5 0 0 1 9.5 8h-4A1.5 1.5 0 0 1 4 6.5zm9 6A1.5 1.5 0 0 1 14.5 10h4A1.5 1.5 0 0 1 20 11.5v1a1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5z" />,
    orders: <path d="M6 5.5A1.5 1.5 0 0 1 7.5 4h9A1.5 1.5 0 0 1 18 5.5V7h1a1 1 0 0 1 1 1v9.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5V8a1 1 0 0 1 1-1h1zm2 0V7h8V5.5zM7 11h5v2H7zm0 4h8v2H7z" />,
    products: <path d="M12 3 4 7v10l8 4 8-4V7zm0 2.2 4.88 2.44L12 10.08 7.12 7.64zM6 9.24l5 2.5v6.51l-5-2.5zm7 9.01v-6.5l5-2.5v6.5z" />,
    customers: <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4m-6.5 7a6.5 6.5 0 0 1 13 0v1h-13zm13.5-7.75a3 3 0 1 0-2.12-.88A3 3 0 0 0 19 11.25M18.5 13a4.5 4.5 0 0 1 4.5 4.5V19h-3v-1.5a7.36 7.36 0 0 0-1.5-4.5" />,
    content: <path d="M6 4h12a2 2 0 0 1 2 2v12l-4-2-4 2-4-2-4 2V6a2 2 0 0 1 2-2m2 4v2h8V8zm0 4v2h5v-2z" />,
    marketing: <path d="M4 12 19 5v14l-5-2.14V22l-3-2v-4.42L7 14H4zm9 2.05 4 1.71V8.24l-4 1.71z" />,
    analytics: <path d="M5 19h14v2H3V5h2zm2-2V9h2v8zm5 0V5h2v12zm5 0v-6h2v6z" />,
    notifications: <path d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22m7-6V11a7 7 0 0 0-5-6.71V3a2 2 0 0 0-4 0v1.29A7 7 0 0 0 5 11v5l-2 2v1h18v-1z" />,
    messages: <path d="M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H8l-4 3v-3H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m2 3v2h12V8zm0 4v2h8v-2z" />,
    team: <path d="M9 11a3 3 0 1 0-3-3 3 3 0 0 0 3 3m6 0a3 3 0 1 0-3-3 3 3 0 0 0 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C22 14.17 17.33 13 15 13M9 13c-2.67 0-8 1.34-8 4v2h5v-2.5A4.66 4.66 0 0 1 8.63 13z" />,
    finance: <path d="M12 3a9 9 0 1 0 9 9 9 9 0 0 0-9-9m1 14.93V19h-2v-1.1a4.34 4.34 0 0 1-3-1.3l1.16-1.65A3.28 3.28 0 0 0 11.5 16c1 0 1.5-.37 1.5-.93s-.42-.86-1.8-1.26c-1.74-.5-2.94-1.2-2.94-2.72A2.86 2.86 0 0 1 11 8.21V7h2v1.17a4.07 4.07 0 0 1 2.57 1l-1.17 1.61A3.17 3.17 0 0 0 12 10c-.86 0-1.28.37-1.28.82 0 .48.5.79 2.04 1.28 1.92.58 2.7 1.38 2.7 2.74A2.94 2.94 0 0 1 13 17.93" />,
    storefront: <path d="M4 8.5 6 4h12l2 4.5M5 10h14v9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm3 4h8m-7-4v10m6-10v10" />,
    asset: <path d="M5 5h14v14H5zm3 3h8m-8 4h5m3 1 2 2m-2-6a1.5 1.5 0 1 1 0-.01" />,
    campaign: <path d="M4 12 18 6v12l-6-2.4V20l-3-2v-3.2L6 14H4zm8 1.33 4 1.6V9.07l-4 1.6z" />,
    reach: <path d="M5 12h4m10 0h-4M12 5v4m0 10v-4m4.95-5.05-2.83 2.83m-4.24 0L7.05 9.95M12 12m-2.5 0a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0" />,
    insight: <path d="M4 19h16M7 16V9m5 7V5m5 11v-4" />,
    audience: <path d="M9 11a3 3 0 1 0-3-3 3 3 0 0 0 3 3m6 0a3 3 0 1 0-3-3 3 3 0 0 0 3 3M3 19a6 6 0 0 1 12 0m2 0h4a4 4 0 0 0-4-4" />,
    stage: <path d="M5 7h14M5 12h10M5 17h6m9-10-3 3 3 3" />,
    service: <path d="M12 21a8 8 0 1 1 8-8m-3 5 4 4m-9-8h.01" />,
    catalog: <path d="M5 5h14v14H5zm3 3h8m-8 4h8m-8 4h5" />,
    supply: <path d="M4 7 12 3l8 4v10l-8 4-8-4zm8-4v18m8-14-8 4-8-4" />,
    crm: <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4m-7 8a7 7 0 0 1 14 0" />,
    inquiry: <path d="M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H8l-4 3v-3H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m3 4h10m-10 4h6" />,
    wallet: <path d="M4 7.5A2.5 2.5 0 0 1 6.5 5H18a2 2 0 0 1 2 2v1h-5a2 2 0 0 0 0 4h5v5a2 2 0 0 1-2 2H6.5A2.5 2.5 0 0 1 4 16.5zm11 4.5h4" />,
    receipt: <path d="M7 4h10v16l-2-1-2 1-2-1-2 1-2-1zM9 8h6M9 12h6M9 16h4" />,
    closing: <path d="M8 3v3m8-3v3M4 8h16m-2 3v7a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-7zm-2-3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2" />,
    audit: <path d="M12 3 5 6v6c0 4.5 2.9 7.6 7 9 4.1-1.4 7-4.5 7-9V6zm-2 9 1.5 1.5L15 10" />,
    governance: <path d="M4 19h16M6 17V9m4 8V9m4 8V9m4 8V9M3 9l9-5 9 5" />,
    hr: <path d="M7 20v-6a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v6M12 11a3 3 0 1 0-3-3 3 3 0 0 0 3 3" />,
    notify: <path d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22m7-6V11a7 7 0 0 0-14 0v5l-2 2v1h18v-1z" />,
    planning: <path d="M7 3v3m10-3v3M5 8h14M6 5h12a1 1 0 0 1 1 1v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1m2 7h3m2 0h3m-8 4h8" />,
    system: <path d="M5 12h14M5 7h14M5 17h14m-3-10v10" />,
    ops: <path d="M10 4 4 7v10l6 3 6-3V7zm0 0 6 3m-6-3v16m0-8 6-3" />,
    settings: <path d="m19.14 12.94.04-.94-.04-.94 2.03-1.58a.5.5 0 0 0 .12-.64l-1.92-3.32a.5.5 0 0 0-.6-.22l-2.39.96a7.42 7.42 0 0 0-1.63-.94L14.5 2.8a.5.5 0 0 0-.5-.4h-4a.5.5 0 0 0-.5.4l-.36 2.52a7.42 7.42 0 0 0-1.63.94l-2.39-.96a.5.5 0 0 0-.6.22L2.6 8.84a.5.5 0 0 0 .12.64l2.03 1.58-.04.94.04.94-2.03 1.58a.5.5 0 0 0-.12.64l1.92 3.32a.5.5 0 0 0 .6.22l2.39-.96a7.42 7.42 0 0 0 1.63.94l.36 2.52a.5.5 0 0 0 .5.4h4a.5.5 0 0 0 .5-.4l.36-2.52a7.42 7.42 0 0 0 1.63-.94l2.39.96a.5.5 0 0 0 .6-.22l1.92-3.32a.5.5 0 0 0-.12-.64zM12 15.5A3.5 3.5 0 1 1 15.5 12 3.5 3.5 0 0 1 12 15.5" />,
    bell: <path d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22m7-6V11a7 7 0 0 0-5-6.71V3a2 2 0 0 0-4 0v1.29A7 7 0 0 0 5 11v5l-2 2v1h18v-1z" />,
    chat: <path d="M4 4h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H8l-4 3v-3H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m2 4v2h12V8zm0 4v2h8v-2z" />,
    chevron: <path d="m9 6 6 6-6 6" />,
    menu: <path d="M4 7h16M4 12h16M4 17h16" />
  };

  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {icons[name] || icons.dashboard}
    </svg>
  );
}

function UserMenu({ avatarLabel, profileName, adminRole, locale, onChangeLocale, onLogout }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`admin-home-user-menu ${open ? "is-open" : ""}`} onBlur={() => setOpen(false)}>
      <button type="button" className="admin-home-user-chip" onClick={() => setOpen((current) => !current)}>
        <div className="admin-home-user-avatar">{avatarLabel}</div>
        <div className="admin-home-user-meta">
          <strong>{profileName}</strong>
          <span>{adminRole || "管理员"}</span>
        </div>
        <span className="admin-home-user-caret"><AdminShellIcon name="chevron" /></span>
      </button>
      {open ? (
        <div className="admin-home-user-dropdown">
          <button type="button" className="admin-home-dropdown-option" onMouseDown={(event) => event.preventDefault()} onClick={() => { onChangeLocale?.("zh"); setOpen(false); }}>
            切换为中文{locale === "zh" ? " ✓" : ""}
          </button>
          <button type="button" className="admin-home-dropdown-option" onMouseDown={(event) => event.preventDefault()} onClick={() => { onChangeLocale?.("en"); setOpen(false); }}>
            Switch to English{locale === "en" ? " ✓" : ""}
          </button>
          <button type="button" className="admin-home-dropdown-option danger" onMouseDown={(event) => event.preventDefault()} onClick={() => { onLogout?.(); setOpen(false); }}>
            退出登录
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default function AdminDashboardShell({
  adminRole,
  profileData,
  onNavigate,
  onLogout,
  onChangeLocale,
  locale = "zh",
  activeTab = "home",
  title = "管理后台",
  subtitle = "欢迎回来，今天有 6 项重点事项等待处理。",
  brandCard = null,
  searchValue = "",
  onSearchChange,
  quickActions = [],
  notificationButton = null,
  messageButton = null,
  allowedTabs = [],
  children
}) {
  const [expandedKeys, setExpandedKeys] = useState(() => ({
    orders: true,
    "orders-fulfillment-group": true,
    "orders-service-group": true,
    products: true,
    "products-catalog-group": true,
    "products-supply-group": true,
    customers: true,
    "customers-crm-group": true,
    "customers-inquiry-group": true,
    "content-brand-group": true,
    "content-assets-group": true,
    marketing: true,
    "marketing-campaign-group": true,
    "marketing-delivery-group": true,
    analytics: true,
    "analytics-business-group": true,
    "analytics-entity-group": true,
    finance: true,
    "finance-funds-group": true,
    "finance-tax-group": true,
    "finance-closing-group": true,
    "finance-report-group": true,
    team: true,
    "team-governance-group": true,
    "team-hr-group": true,
    notifications: true,
    "notifications-delivery-group": true,
    "notifications-plan-group": true,
    settings: true,
    "settings-core-group": true,
    "settings-ops-group": true
  }));
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const selectedMenu = useMemo(() => getAdminShellActiveMenu(activeTab), [activeTab]);
  const allowedTabSet = useMemo(
    () => new Set(Array.isArray(allowedTabs) ? allowedTabs.map((item) => String(item || "").trim()).filter(Boolean) : []),
    [allowedTabs]
  );
  const visibleMenuGroups = useMemo(() => {
    const allMenuGroups = ADMIN_SHELL_MENU_GROUPS
      .map((group) => ({
        ...group,
        items: group.items.map((item) => ({
          ...item,
          children: Array.isArray(item.children) ? item.children : []
        }))
      }))
      .filter((group) => group.items.length);

    if (!allowedTabSet.size) {
      return allMenuGroups;
    }

    const filteredMenuGroups = ADMIN_SHELL_MENU_GROUPS
      .map((group) => ({
        ...group,
        items: group.items
          .map((item) => {
            const normalizedRoute = String(item?.route || "").trim();
            const childItems = Array.isArray(item.children)
              ? filterAllowedChildren(item.children, activeTab, allowedTabSet)
              : [];
            const routeAllowed = normalizedRoute === "home" || normalizedRoute === String(activeTab || "").trim() || allowedTabSet.has(normalizedRoute);

            if (childItems.length) {
              return {
                ...item,
                children: childItems
              };
            }

            if (!routeAllowed) {
              return null;
            }

            return item;
          })
          .filter(Boolean)
      }))
      .filter((group) => group.items.length);

        return filteredMenuGroups.length ? filteredMenuGroups : allMenuGroups;
        }, [activeTab, allowedTabSet]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 768) {
        setMobileSidebarOpen(false);
      }
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const selectedParent = ADMIN_SHELL_MENUS.find((item) => itemHasSelectedDescendant(item, selectedMenu));
    if (selectedParent?.key) {
      setExpandedKeys((current) => {
        const nextState = current[selectedParent.key] === false ? { ...current, [selectedParent.key]: true } : current;
        const matchingGroup = Array.isArray(selectedParent.children)
          ? selectedParent.children.find((child) => itemHasSelectedDescendant(child, selectedMenu))
          : null;

        if (matchingGroup?.key && nextState[matchingGroup.key] === false) {
          return { ...nextState, [matchingGroup.key]: true };
        }

        return nextState;
      });
    }
  }, [selectedMenu]);

  useEffect(() => {
    if (!mobileSidebarOpen) {
      document.body.style.overflow = "";
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    function handleKeyDown(event) {
      if (event.key === "Escape") {
        setMobileSidebarOpen(false);
      }
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [mobileSidebarOpen]);

  const profileName = String(profileData?.name || profileData?.username || "管理员").trim() || "管理员";
  const avatarLabel = profileName.slice(0, 1).toUpperCase();
  const brandTitle = String(brandCard?.adminTitle || brandCard?.title || "LOYA Dashboard").trim() || "LOYA Dashboard";
  const brandLogoUrl = String(brandCard?.logoUrl || "").trim();
  const brandLogoAlt = String(brandCard?.logoAlt || brandTitle).trim() || brandTitle;
  const notificationCount = Math.max(0, Number(notificationButton?.count || 0) || 0);
  const messageCount = Math.max(0, Number(messageButton?.count || 0) || 0);
  const notificationLabel = notificationButton?.label || (locale === "zh" ? "打开系统通知面板" : "Open system notifications");
  const messageLabel = messageButton?.label || (locale === "zh" ? "打开询盘与即时消息面板" : "Open inquiry and instant-message panel");
  const handleNotificationClick = typeof notificationButton?.onClick === "function" ? notificationButton.onClick : undefined;
  const handleMessageClick = typeof messageButton?.onClick === "function" ? messageButton.onClick : undefined;
  const notificationDisabled = notificationButton?.disabled ?? !handleNotificationClick;
  const messageDisabled = messageButton?.disabled ?? !handleMessageClick;

  function handleMenuClick(item) {
    if (item.children?.length) {
      setExpandedKeys((current) => ({ ...current, [item.key]: !current[item.key] }));
      return;
    }

    setMobileSidebarOpen(false);
    if (item.route) {
      onNavigate?.(item.route);
    }
  }

  function handleParentNavigate(item) {
    if (item.route) {
      onNavigate?.(item.route);
      setMobileSidebarOpen(false);
    }
  }

  function renderSubmenuNode(node, depth = 0) {
    const hasChildren = Array.isArray(node.children) && node.children.length > 0;
    const isExpanded = expandedKeys[node.key] !== false;
    const isActive = selectedMenu === node.key || itemHasSelectedDescendant(node, selectedMenu);

    if (hasChildren) {
      return (
        <div key={node.key} className={`admin-home-submenu-group depth-${depth} ${isActive ? "is-active" : ""}`}>
          <button
            type="button"
            className={`admin-home-submenu-group-toggle ${isActive ? "is-active" : ""}`}
            onClick={() => handleMenuClick(node)}
          >
            <span className="admin-home-submenu-group-toggle-main">
              {node.icon ? <span className="admin-home-submenu-group-icon"><AdminShellIcon name={node.icon} /></span> : null}
              <span className="admin-home-submenu-group-label">{node.label}</span>
            </span>
            <span className={`admin-home-caret ${isExpanded ? "is-open" : ""}`}><AdminShellIcon name="chevron" /></span>
          </button>
          <div className={`admin-home-submenu-group-children ${isExpanded ? "is-open" : ""}`}>
            {node.children.map((child) => renderSubmenuNode(child, depth + 1))}
          </div>
        </div>
      );
    }

    return (
      <button
        key={node.key}
        type="button"
        className={`admin-home-submenu-item admin-home-submenu-item-depth-${depth} ${selectedMenu === node.key ? "is-active" : ""}`}
        onClick={() => handleMenuClick(node)}
      >
        <span>{node.label}</span>
      </button>
    );
  }

  return (
    <section className="controlhub-admin-shell admin-home-shell">
      <aside className={`admin-home-sidebar ${mobileSidebarOpen ? "is-open" : ""}`}>
        <div className="admin-home-brand">
          <div className={`admin-home-brand-icon ${brandLogoUrl ? "has-image" : ""}`}>
            {brandLogoUrl ? <img src={brandLogoUrl} alt={brandLogoAlt} loading="lazy" /> : <span>{brandTitle.slice(0, 1).toUpperCase()}</span>}
          </div>
          <div>
            <strong>{brandTitle}</strong>
          </div>
        </div>

        <nav className="admin-home-menu" aria-label="后台导航">
          {visibleMenuGroups.map((group) => (
            <div key={group.key} className="admin-home-menu-section">
              <p className="admin-home-menu-section-label">{group.label}</p>
              {group.items.map((item) => {
                const hasChildren = Array.isArray(item.children) && item.children.length > 0;
                const isExpanded = expandedKeys[item.key] !== false;
                const isActive = selectedMenu === item.key || itemHasSelectedDescendant(item, selectedMenu);

                return (
                  <div key={item.key} className="admin-home-menu-group">
                    <button
                      type="button"
                      className={`admin-home-menu-item ${isActive ? "is-active" : ""}`}
                      onClick={() => (hasChildren ? handleMenuClick(item) : handleParentNavigate(item))}
                    >
                      <span className="admin-home-menu-item-main">
                        <span className="admin-home-menu-icon"><AdminShellIcon name={item.key} /></span>
                        <span>{item.label}</span>
                      </span>
                      <span className="admin-home-menu-item-side">
                        {item.badge ? <span className="admin-home-badge danger">{item.badge}</span> : null}
                        {hasChildren ? <span className={`admin-home-caret ${isExpanded ? "is-open" : ""}`}><AdminShellIcon name="chevron" /></span> : null}
                      </span>
                    </button>

                    {hasChildren ? (
                      <div className={`admin-home-submenu ${isExpanded ? "is-open" : ""}`}>
                        {item.children.map((child) => renderSubmenuNode(child))}
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          ))}
        </nav>

        <div className="admin-home-enterprise-card admin-home-brand-portal-card">
          <div className={`admin-home-enterprise-logo ${brandLogoUrl ? "has-image" : ""}`}>
            {brandLogoUrl ? (
              <img src={brandLogoUrl} alt={brandLogoAlt} loading="lazy" />
            ) : (
              <span>{brandTitle.slice(0, 1).toUpperCase()}</span>
            )}
          </div>
          <div className="admin-home-enterprise-copy compact">
            <strong>{title}</strong>
          </div>
        </div>
      </aside>

      <div className="admin-home-main-shell">
        <header className="admin-home-topbar">
          <div className="admin-home-topbar-left">
            <button type="button" className="admin-home-mobile-menu" onClick={() => setMobileSidebarOpen((current) => !current)}>
              <AdminShellIcon name="menu" />
            </button>
            <div>
              <h1>{title}</h1>
              <p>{subtitle}</p>
            </div>
          </div>

          <div className="admin-home-topbar-right">
            {quickActions.length ? (
              <div className="admin-home-quick-actions">
                {quickActions.map((item) => (
                  <button
                    key={item.key}
                    type="button"
                    className={`admin-home-toolbar-button ${item.tone === "primary" ? "is-primary" : ""}`}
                    onClick={item.onClick}
                  >
                    {item.icon ? <span className="admin-home-toolbar-icon"><AdminShellIcon name={item.icon} /></span> : null}
                    <span>{item.label}</span>
                  </button>
                ))}
              </div>
            ) : null}
            <label className="admin-home-search">
              <input type="search" placeholder="搜索订单、商品、客户等" value={searchValue} onChange={(event) => onSearchChange?.(event.target.value)} />
              <span>Ctrl K</span>
            </label>
            <button
              type="button"
              className="admin-home-icon-button"
              onClick={handleNotificationClick}
              disabled={notificationDisabled}
              title={notificationLabel}
              aria-label={notificationLabel}
            >
              <AdminShellIcon name="bell" />
              {notificationCount ? <span className="admin-home-badge danger">{notificationCount}</span> : null}
            </button>
            <button
              type="button"
              className="admin-home-icon-button"
              onClick={handleMessageClick}
              disabled={messageDisabled}
              title={messageLabel}
              aria-label={messageLabel}
            >
              <AdminShellIcon name="chat" />
              {messageCount ? <span className="admin-home-badge danger">{messageCount}</span> : null}
            </button>
            <UserMenu
              avatarLabel={avatarLabel}
              profileName={profileName}
              adminRole={adminRole}
              locale={locale}
              onChangeLocale={onChangeLocale}
              onLogout={onLogout}
            />
          </div>
        </header>

        <main className="admin-home-content">{children}</main>
      </div>

      <div className={`admin-home-backdrop ${mobileSidebarOpen ? "is-open" : ""}`} onClick={() => setMobileSidebarOpen(false)} />
    </section>
  );
}